<script setup>
import { computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { frontendURL } from '../../../../helper/URLHelper';
import Knowledgebase from './Knowledgebase.vue';
import Spinner from 'shared/components/Spinner.vue';
import { useRoute, onBeforeRouteLeave } from 'vue-router';

const store = useStore();
const route = useRoute();

const selectedKnowledgebase = computed(
  () => store.getters['knowledgebase/getSelectedLibrary']
);

// Generate back URL from route params
const backUrl = computed(() => {
  return frontendURL(
    `accounts/${route.params.accountId}/settings/knowledgebases`
  );
});

const fetchKnowledgebase = knowledgebaseId => {
  store.dispatch('knowledgebase/getSingleLibrary', knowledgebaseId);
};

onMounted(() => {
  fetchKnowledgebase(route.params.knowledgebaseId);
});

watch(
  () => route.params.knowledgebaseId,
  newKnowledgebaseId => {
    if (newKnowledgebaseId !== selectedKnowledgebase.value.id) {
      fetchKnowledgebase(newKnowledgebaseId);
    }
  }
);

onBeforeRouteLeave((to, from, next) => {
  store.dispatch('knowledgebase/clearSelectedKnowledgebase');
  next();
});
</script>

<template>
  <div class="flex-1 flex items-start w-full">
    <Knowledgebase
      v-if="selectedKnowledgebase"
      :knowledgebase="selectedKnowledgebase"
      show-back-button
      :back-url="backUrl"
      :back-button-label="$t('LIBRARIES.HEADER')"
    />
    <div v-else class="items-center flex text-base justify-center">
      <Spinner color-scheme="primary" />
      <span>{{ $t('LIBRARIES.CONTENT.LOADING_MESSAGE') }}</span>
    </div>
  </div>
</template>
